import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export default function useActiveSymbolIsin() {
  const route = useRoute();
  const router = useRouter();

  const activeIsin = computed<string>(() => route.query.isin as string);

  const updateActiveIsin = async (isin: string | null) => {
    if (isin) {
      await router.replace({ path: '/', query: { ...route.query, isin } });
    }
  };

  return {
    activeIsin,
    updateActiveIsin,
  };
}
